import { Chip } from '@material-ui/core';
import { XIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { createAdminPageStyles } from '../../style';
import { CategoryTestOption } from '../types';
import { categoryTestLabel } from '../utils';
import SearchAutocomplete from './SearchAutocomplete';

interface CategoryTestsAutocompleteProps {
  id: string;
  options: CategoryTestOption[];
  value: CategoryTestOption[];
  disabled?: boolean;
  placeholder?: string;
  onChange: (next: CategoryTestOption[]) => void;
}

const useStyles = createAdminPageStyles({});

const CategoryTestsAutocomplete: FC<CategoryTestsAutocompleteProps> = ({
  id,
  options,
  value,
  disabled = false,
  placeholder = 'Rechercher une catégorie',
  onChange,
}) => {
  const classes = useStyles();

  return (
    <SearchAutocomplete
      id={id}
      multiple={true}
      options={options}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      getOptionLabel={categoryTestLabel}
      onChange={selected => onChange((selected as CategoryTestOption[]) || [])}
      renderTags={(tags, getTagProps) =>
        tags.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.id}
            className={classes.serviceChip}
            label={categoryTestLabel(option)}
            style={{ margin: 2 }}
            deleteIcon={<XIcon size={14} />}
          />
        ))
      }
    />
  );
};

export default CategoryTestsAutocomplete;
